import type {} from "@lit/react";
import { GridFilterColumn as GridFilterColumnElement, } from "@vaadin/grid/vaadin-grid-filter-column.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { GridFilterColumnElement, };
export type GridFilterColumnEventMap = Readonly<{}>;
const events = {} as GridFilterColumnEventMap;
export type GridFilterColumnProps<T1> = WebComponentProps<GridFilterColumnElement<T1>, GridFilterColumnEventMap>;
export const GridFilterColumn = createComponent({
    elementClass: GridFilterColumnElement, events, react: React, tagName: "vaadin-grid-filter-column"
}) as <T1>(props: GridFilterColumnProps<T1> & React.RefAttributes<GridFilterColumnElement<T1>>) => React.ReactElement | null;
